export function announceTagRemove(_a, label) {
    var ariaLiveMessages = _a.ariaLiveMessages;
    return label ? ariaLiveMessages.tagRemove({ label: label }) : '';
}
export function announceTagCreate(_a, option) {
    var ariaLiveMessages = _a.ariaLiveMessages;
    return ariaLiveMessages.tagCreate({ label: option });
}
export function announceOptionSelect(_a, label) {
    var ariaLiveMessages = _a.ariaLiveMessages;
    return ariaLiveMessages.optionSelect({ label: label });
}
export function announceTagFocus(_a, tagLabel, tags) {
    var ariaLiveMessages = _a.ariaLiveMessages;
    var index = tags.findIndex(function (tag) { return tag.label === tagLabel; });
    var instructions = index + 1 === tags.length ? ariaLiveMessages.tagInstructions : '';
    return "".concat(ariaLiveMessages.tagFocus({
        label: tagLabel,
        current: index + 1,
        total: tags.length,
    }), " ").concat(instructions);
}
export function announceInputFocus(props) {
    var label = props.label, isSearchable = props.isSearchable, isMulti = props.isMulti, ariaLiveMessages = props.ariaLiveMessages;
    return "\n    ".concat(ariaLiveMessages.inputFocus({ label: label }), "\n    ").concat(isSearchable === false ? '' : ariaLiveMessages.inputFocusIsSearchable, "\n    ").concat(isMulti === false ? '' : ariaLiveMessages.inputFocusIsMulti, "\n  ");
}
export function announceMenuInstructions(_a) {
    var ariaLiveMessages = _a.ariaLiveMessages;
    return ariaLiveMessages.menuInstructions;
}
export function announceOptionFocus(_a, optionLabel, options) {
    var ariaLiveMessages = _a.ariaLiveMessages;
    if (!options) {
        return '';
    }
    var index = options.findIndex(function (option) { return option.label === optionLabel; });
    return ariaLiveMessages.optionFocus({
        label: optionLabel,
        current: index + 1,
        total: options.length,
    });
}
export function announceSearchResults(_a, value, resultsCount, isValidNewOption) {
    var ariaLiveMessages = _a.ariaLiveMessages, isCreatable = _a.isCreatable;
    if (value && isCreatable && isValidNewOption) {
        return ariaLiveMessages.searchResultsIsCreatable({ value: value, count: resultsCount });
    }
    return value
        ? ariaLiveMessages.searchResults({ value: value, count: resultsCount })
        : ariaLiveMessages.optionsAvailable({ count: resultsCount });
}
export function getOnChangeAriaLiveMessage(props, value, action) {
    var ariaMessage = '';
    var label;
    switch (action.action) {
        case 'deselect-option':
        case 'pop-value':
        case 'remove-value':
            // When isMulti is true and nothing is selected, hitting 'backspace' sends a 'pop-value' change with an empty array as the value.
            // In this case, we don't actually want the aria-live message updated so return null.
            if (props.isMulti && value && 'length' in value && value.length === 0) {
                return null;
            }
            label = props.isMulti
                ? getRemovedOptionLabel(action)
                : getOptionLabel(value);
            ariaMessage = announceTagRemove(props, label);
            break;
        case 'select-option':
            label = props.isMulti
                ? getSelectedOptionLabel(action)
                : getOptionLabel(value);
            ariaMessage = announceOptionSelect(props, label);
            break;
        case 'create-option':
            label = props.isMulti
                ? getCreatedOptionLabel(value, props.createOptionPosition)
                : getOptionLabel(value);
            ariaMessage = announceTagCreate(props, label);
            break;
    }
    if (props.isMulti) {
        ariaMessage = "".concat(ariaMessage, " ").concat(announceInputFocus(props));
    }
    return ariaMessage;
}
function getOptionLabel(option) {
    return option && option.label;
}
function getSelectedOptionLabel(action) {
    return action && action.option && action.option.label;
}
function getRemovedOptionLabel(action) {
    return action && action.removedValue && action.removedValue.label;
}
function getCreatedOptionLabel(value, createOptionPosition) {
    if (value.length === 0) {
        return '';
    }
    return createOptionPosition === 'first' ? value[0].label : value[value.length - 1].label;
}
//# sourceMappingURL=PickerAccessibility.js.map